module.exports = __webpack_public_path__ + "static/media/yatra-hmpr-format.0f57dcdd.xlsx";